// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../reducers';
import {
  selectSalesTeamsInStore,
  selectSalesTeamsPageLoading,
  selectSalesTeamsShowInitWaitingMessage,
} from '../_selectors/sales-team.selectors';

export class SalesTeamsDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectSalesTeamsPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(select(selectSalesTeamsShowInitWaitingMessage));

    this.store.pipe(select(selectSalesTeamsInStore)).subscribe((response: QueryResultsModel) => {
      this.paginatorTotalSubject.next(response.totalCount);
      this.entitySubject.next(response.items);
    });
  }
}
